<template>
  <WorkspaceRoleDenied v-if="staffDenied" :area="t('integracao.area')" />
  <div v-else class="workspace-integracao-page">
    <div class="modern-header">
      <div class="header-container">
        <div class="breadcrumb-section">
          <nav class="breadcrumb">
            <button type="button" class="breadcrumb-item" @click="$router.push('/dashboard')">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
              </svg>
              {{ t('common.breadcrumb.dashboard') }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <button type="button" class="breadcrumb-item" @click="$router.push(`/workspace/${workspaceId}/dashboard`)">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              {{ workspaceName }}
            </button>
            <span class="breadcrumb-separator">/</span>
            <span class="breadcrumb-current">{{ t('integracao.breadcrumbCurrent') }}</span>
          </nav>
        </div>

        <div class="title-section">
          <div class="title-content">
            <div class="title-icon title-icon--integrations">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"/>
              </svg>
            </div>
            <div class="title-text">
              <h1 class="main-title">{{ t('integracao.title') }}</h1>
              <p class="subtitle">{{ t('integracao.subtitle') }}</p>
            </div>
          </div>

          <div class="workspace-badge" :class="`type-${(workspaceTipo || 'tarefas').toLowerCase()}`">
            <div class="badge-icon">
              <svg v-if="workspaceTipo === 'CRM'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
              </svg>
              <svg v-else-if="workspaceTipo === 'SERVICOS'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
              </svg>
              <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
              </svg>
            </div>
            <span class="badge-text">{{ workspaceTipo || 'TAREFAS' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="integracao-page-content">
    <div class="integrations-grid">
      <!-- WhatsApp Integration -->
      <WhatsAppIntegrationCard 
        :workspaceId="workspaceId"
        @connection-updated="handleConnectionUpdate"
      />

      <!-- IA — reativar: showIntegracaoIa = true -->
      <div v-if="showIntegracaoIa" class="ai-integration-wrapper">
        <AIIntegrationCard
          :workspaceId="workspaceId"
          @connection-updated="handleConnectionUpdate"
        />
      </div>

      <!-- Email — reativar: showIntegracaoEmail = true -->
      <div v-if="showIntegracaoEmail" class="integration-card coming-soon">
        <div class="integration-icon">
          <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
        </div>
        <h3 class="integration-title">{{ t('integracao.emailTitle') }}</h3>
        <p class="integration-description">
          {{ t('integracao.emailDescription') }}
        </p>
        <div class="coming-soon-badge">
          {{ t('integracao.comingSoon') }}
        </div>
      </div>

      <!-- Telegram — reativar: showIntegracaoTelegram = true -->
      <div v-if="showIntegracaoTelegram" class="integration-card coming-soon">
        <div class="integration-icon">
          <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
          </svg>
        </div>
        <h3 class="integration-title">{{ t('integracao.telegramTitle') }}</h3>
        <p class="integration-description">
          {{ t('integracao.telegramDescription') }}
        </p>
        <div class="coming-soon-badge">
          {{ t('integracao.comingSoon') }}
        </div>
      </div>
    </div>

    <div v-if="isCrmWorkspace" class="integrations-extended">
      <LeadCaptureFormsSection :workspace-id="workspaceId" />
      <AgendamentoFormsSection :workspace-id="workspaceId" workspace-tipo="CRM" />
      <LeadApiIntegrationSection :workspace-id="workspaceId" />
    </div>

    <div v-if="isServicosWorkspace" class="integrations-extended">
      <AgendamentoFormsSection :workspace-id="workspaceId" workspace-tipo="SERVICOS" />
    </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import WhatsAppIntegrationCard from '@/components/WhatsAppIntegrationCard.vue'
import AIIntegrationCard from '@/components/AIIntegrationCard.vue'
import LeadCaptureFormsSection from '@/components/integrations/LeadCaptureFormsSection.vue'
import LeadApiIntegrationSection from '@/components/integrations/LeadApiIntegrationSection.vue'
import AgendamentoFormsSection from '@/components/integrations/AgendamentoFormsSection.vue'
import WorkspaceRoleDenied from '@/components/workspace/WorkspaceRoleDenied.vue'
import { useWorkspaceStaffGuard } from '@/composables/useWorkspaceStaffGuard'
import { useGlobalWorkspaces } from '@/composables/useGlobalWorkspaces'
import { useWorkspaceStore } from '@/stores/workspace'
import { isCrmWorkspace, isServicosWorkspace } from '@/utils/workspaceTipo'

export default {
  name: 'WorkspaceIntegracaoPage',
  components: {
    WhatsAppIntegrationCard,
    AIIntegrationCard,
    LeadCaptureFormsSection,
    LeadApiIntegrationSection,
    AgendamentoFormsSection,
    WorkspaceRoleDenied
  },
  setup() {
    const route = useRoute()
    const { t } = useI18n()
    const workspaceId = computed(() => Number(route.params.id))
    const workspaceStore = useWorkspaceStore()
    const { currentWorkspace } = useGlobalWorkspaces()
    const { staffDenied } = useWorkspaceStaffGuard(t('integracao.area'))
    const workspaceForTipo = computed(
      () => currentWorkspace.value ?? workspaceStore.currentWorkspace
    )
    const isCrmWorkspaceFlag = computed(() => isCrmWorkspace(workspaceForTipo.value))
    const isServicosWorkspaceFlag = computed(() => isServicosWorkspace(workspaceForTipo.value))

    const workspaceName = computed(
      () => workspaceForTipo.value?.nome || t('workspaceDashboard.defaultName')
    )

    const workspaceTipo = computed(() => workspaceForTipo.value?.tipo || 'TAREFAS')

    /** Reativar integrações ocultas alterando para true */
    const showIntegracaoIa = false
    const showIntegracaoEmail = false
    const showIntegracaoTelegram = false

    const handleConnectionUpdate = (data) => {
      console.log('📡 Conexão atualizada:', data)
    }

    const syncWorkspaceFromRoute = async (id) => {
      if (!id || Number.isNaN(id)) return
      await workspaceStore.loadWorkspace(id)
    }

    onMounted(() => {
      console.log('📱 WorkspaceIntegracaoPage montada - Workspace:', workspaceId.value)
      syncWorkspaceFromRoute(workspaceId.value)
    })

    watch(
      () => route.params.id,
      (id) => {
        const parsed = Number(id)
        if (!parsed || Number.isNaN(parsed)) return
        syncWorkspaceFromRoute(parsed)
      }
    )

    return {
      t,
      staffDenied,
      workspaceId,
      showIntegracaoIa,
      showIntegracaoEmail,
      showIntegracaoTelegram,
      handleConnectionUpdate,
      isCrmWorkspace: isCrmWorkspaceFlag,
      isServicosWorkspace: isServicosWorkspaceFlag,
      workspaceName,
      workspaceTipo
    }
  }
}
</script>

<style scoped>
.workspace-integracao-page {
  padding: 0;
  min-height: 100vh;
  background: linear-gradient(135deg, var(--bg-primary) 0%, var(--bg-secondary) 100%);
}

.modern-header {
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-primary);
  padding: 24px 0;
  margin-bottom: 24px;
}

.header-container {
  width: 100%;
  padding: 0 24px;
}

.breadcrumb-section {
  margin-bottom: 16px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  flex-wrap: wrap;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
}

.breadcrumb-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.breadcrumb-separator {
  color: var(--text-tertiary, var(--text-secondary));
  font-weight: 500;
}

.breadcrumb-current {
  color: var(--text-primary);
  font-weight: 600;
  padding: 6px 12px;
  background: var(--bg-secondary);
  border-radius: 4px;
}

.title-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.title-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.title-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  color: #fff;
  flex-shrink: 0;
}

.title-icon--integrations {
  background: linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
}

.main-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.2;
}

.subtitle {
  font-size: 1rem;
  color: var(--text-secondary);
  margin: 0;
  font-weight: 400;
}

.workspace-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.workspace-badge.type-crm {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.workspace-badge.type-tarefas {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.workspace-badge.type-servicos {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #fff;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
}

.badge-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.integracao-page-content {
  width: 100%;
  padding: 0 24px 48px;
  box-sizing: border-box;
}

.integrations-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 1400px;
}

.integrations-extended {
  max-width: 1400px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ai-integration-wrapper {
  grid-column: span 2;
}

.integration-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 4px;
  padding: 24px;
  transition: all 0.3s ease;
}

.integration-card:hover {
  border-color: var(--border-hover);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.integration-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-bottom: 16px;
}

.integration-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.integration-description {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin-bottom: 16px;
}

.coming-soon {
  position: relative;
  opacity: 0.6;
  cursor: not-allowed;
}

.coming-soon:hover {
  transform: none;
  box-shadow: none;
}

.coming-soon-badge {
  display: inline-block;
  padding: 6px 12px;
  background: #fbbf24;
  color: #78350f;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .modern-header {
    padding: 16px 0;
    margin-bottom: 16px;
  }

  .header-container,
  .integracao-page-content {
    padding-left: 16px;
    padding-right: 16px;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .integrations-grid {
    grid-template-columns: 1fr;
  }
}
</style>

